import React, { Fragment } from 'react';
import { MobileView, IOSView, AndroidView, BrowserView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import Text from '../shared/Typography';
import Card from '../shared/Card';
import IOSButton from '../shared/ButtonIOS';
import AndroidButton from '../shared/ButtonAndroid';

import nativeApp from '../../assets/images/native-app.png';

type Props = {
  text?: string
}

export const Content = ({ text }: Props) => {
  const { t } = useTranslation('nativeAppBanner');

  return (
    <Fragment>
      <div className='native-app-banner__img'>
        <img src={nativeApp} alt={t('download_ios')} />
      </div>
      <div className='native-app-banner__cta'>
        <Text h2>{text || ''}</Text>
        <Text paragraph>{t('available_iOS_Android')}</Text>
        <div className='native-app-banner__stores'>
          <IOSButton />
          <AndroidButton />
        </div>
      </div>
    </Fragment>
  );
};

const NativeAppBannerMobile = () => {
  const { t } = useTranslation('nativeAppBanner');

  return (
    <MobileView>
      <div className='native-app-banner--mobile'>
        <Text h2>{t('download_for_speed')}</Text>
        <IOSView>
          <IOSButton />
        </IOSView>
        <AndroidView>
          <AndroidButton />
        </AndroidView>
      </div>
    </MobileView>
  );
};

const NativeAppBannerDesktop = () => (
  <BrowserView>
    <Card noShadow className='native-app-banner--desktop'>
      <div className='native-app-banner__inner'>
        <Content />
      </div>
    </Card>
  </BrowserView>
);

const SignUpAppBanner = ({ text }: Props) => (
  <div className='native-app-banner--signup'>
    <Content text={text} />
  </div>
);

export {
  NativeAppBannerMobile,
  NativeAppBannerDesktop,
  SignUpAppBanner
};


// WEBPACK FOOTER //
// ./src/components/shared/native-app-banner.js